import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Image from 'react-bootstrap/Image'
import Tab from 'react-bootstrap/Tab'
import Nav from 'react-bootstrap/Nav'

const Analyst = ({ Index, Name, Avatar }) => (
  <Nav.Item>
    <Nav.Link eventKey={Index}>
      <Image src={Avatar[0].url} width={42} roundedCircle />
      <span className="ml-2 d-none d-sm-inline-block">{Name}</span>
    </Nav.Link>
  </Nav.Item>
);

const Picks = ({ Index, Name, Avatar, Role, URL, Race, RaceTwo, RaceURL, RaceTwoURL, Purse, One, Three, Alternate, Two, Six, Five, Four, AlternateTwo, PurseTwo,
  TopSelections, ExactaEarnings, TrifectaEarnings, RaceThree, PurseThree, RaceThreeURL, Seven, Eight, Nine, AlternateThree, Ten, Eleven, Twelve, AlternateFour, RaceFour, PurseFour, RaceFourURL }) => (
  <Tab.Pane eventKey={Index}>
    <h4 className="title mb-3 mt-2">The Players' Picks</h4>
    <Card bg="light" border="0" body>
      <Row>
        <Col>
          <Image src={Avatar[0].url} width={72} roundedCircle className="float-right" />
          <a href={URL} target="_blank" rel="noopener noreferrer">
            <h5 className="mb-1 title">{Name}</h5>
          </a>
          <p className="text-muted mb-2 mt-0 font-italic">{Role}</p>
        </Col>
      </Row>
      <Row>
        <Col className="border-right">
          <small className="text-muted">Top Selections</small>
          <p className="mb-0 title">{TopSelections}</p>
        </Col>
        <Col className="border-right">
          <small className="text-muted">Exacta Earnings</small>
          <p className="mb-0 title">{ExactaEarnings}</p>
        </Col>
        <Col>
          <small className="text-muted">Trifecta Earnings</small>
          <p className="mb-0 title">{TrifectaEarnings}</p>
        </Col>
      </Row>
    </Card>
    <Card className="p-3 mt-3">
      <Row>
        <Col>
          <span className="float-right title">Purse: ${Purse}</span>
          <a href={RaceURL} target="_blank" rel="noopener noreferrer"><h5 className="title" style={{ marginBottom: 0 }}>{Race}</h5></a>
        </Col>
      </Row>
      <hr></hr>
      <Row>
        <Col lg={6} md={6} xs={6}>
          <small className="font-weight-bold">1st</small>
          <p className="mb-0 font-weight-bold">{One}</p>
        </Col>
        <Col lg={6} md={6} xs={6}>
          <small className="text-muted">2nd</small>
          <p className="mb-0">{Two}</p>
        </Col>
      </Row>
      <hr></hr>
      <Row>
        <Col lg={6} md={6} xs={6}>
          <small className="text-muted">3rd</small>
          <p className="mb-0">{Three}</p>
        </Col>
        <Col lg={6} md={6} xs={6}>
          <small className="text-muted">Alternate</small>
          <p className="mb-0 text-muted">{Alternate}</p>
        </Col>
      </Row>
    </Card>
    {RaceTwo ? (
      <Card className="p-3 mt-3">
        <Row>
          <Col>
            <span className="float-right title">Purse: ${PurseTwo}</span>
            <a href={RaceTwoURL} target="_blank" rel="noopener noreferrer"><h5 className="title">{RaceTwo}</h5></a>
          </Col>
        </Row>
        <hr></hr>
        <Row>
          <Col lg={6} md={6} xs={6}>
            <small className="font-weight-bold">1st</small>
            <p className="mb-0 font-weight-bold">{Four}</p>
          </Col>
          <Col lg={6} md={6} xs={6}>
            <small className="text-muted">2nd</small>
            <p className="mb-0">{Five}</p>
          </Col>
        </Row>
        <hr></hr>
        <Row>
          <Col lg={6} md={6} xs={6}>
            <small className="text-muted">3rd</small>
            <p className="mb-0">{Six}</p>
          </Col>
          <Col lg={6} md={6} xs={6}>
            <small className="text-muted">Alternate</small>
            <p className="mb-0 text-muted">{AlternateTwo}</p>
          </Col>
        </Row>
      </Card>
    ) : null}
    {RaceThree ? (
      <Card className="p-3 mt-3">
        <Row>
          <Col>
            <span className="float-right title">Purse: ${PurseThree}</span>
            <a href={RaceThreeURL} target="_blank" rel="noopener noreferrer"><h5 className="title">{RaceThree}</h5></a>
          </Col>
        </Row>
        <hr></hr>
        <Row>
          <Col lg={6} md={6} xs={6}>
            <small className="font-weight-bold">1st</small>
            <p className="mb-0 font-weight-bold">{Seven}</p>
          </Col>
          <Col lg={6} md={6} xs={6}>
            <small className="text-muted">2nd</small>
            <p className="mb-0">{Eight}</p>
          </Col>
        </Row>
        <hr></hr>
        <Row>
          <Col lg={6} md={6} xs={6}>
            <small className="text-muted">3rd</small>
            <p className="mb-0">{Nine}</p>
          </Col>
          <Col lg={6} md={6} xs={6}>
            <small className="text-muted">Alternate</small>
            <p className="mb-0 text-muted">{AlternateThree}</p>
          </Col>
        </Row>
      </Card>
    ) : null}
    {RaceFour ? (
      <Card className="p-3 mt-3">
        <Row>
          <Col>
            <span className="float-right title">Purse: ${PurseFour}</span>
            <a href={RaceFourURL} target="_blank" rel="noopener noreferrer"><h5 className="title">{RaceFour}</h5></a>
          </Col>
        </Row>
        <hr></hr>
        <Row>
          <Col lg={6} md={6} xs={6}>
            <small className="font-weight-bold">1st</small>
            <p className="mb-0 font-weight-bold">{Ten}</p>
          </Col>
          <Col lg={6} md={6} xs={6}>
            <small className="text-muted">2nd</small>
            <p className="mb-0">{Eleven}</p>
          </Col>
        </Row>
        <hr></hr>
        <Row>
          <Col lg={6} md={6} xs={6}>
            <small className="text-muted">3rd</small>
            <p className="mb-0">{Twelve}</p>
          </Col>
          <Col lg={6} md={6} xs={6}>
            <small className="text-muted">Alternate</small>
            <p className="mb-0 text-muted">{AlternateFour}</p>
          </Col>
        </Row>
      </Card>
    ) : null}
    <Row style={{ marginTop: 16 }}>
      <Col>
        <Image src="https://www.americasbestracing.net/sites/all/themes/custom/abr_theme/img/logos/equibase.svg"
          width={82} />
      </Col>
      <Col align="right">
        <small><a href="https://www.tallysight.com/" target="_blank" rel="noopener noreferrer" className="text-muted font-italic">Powered by Tallysight</a></small>
      </Col>
    </Row>
  </Tab.Pane>
);

const HorseRaceWidget = () => {
  const [predictions, setPredictions] = useState([]);
  const params = useParams();
  // console.log(params);
  useEffect(() => {
    //Fetch prediction data
    fetch(`https://api.airtable.com/v0/app5tsAm7aoHtBm31/${params.raceName}?sort%5B0%5D%5Bfield%5D=Index`,
      {
        headers: {
          Authorization:
            "Bearer pat3O9j33YUieQJTW.8aa9ccee36eb1863d5255e070df8e8884b715f6de33cfdd9dddf631f9b5a7f1f",
        },
      })
      .then((resp) => resp.json())
      .then(data => {
        setPredictions(data.records);
      }).catch(err => {
        // Error :(
      });
  }, []);




  const playerCount = predictions.length;

  return (
    <Card body style={{ borderRadius: 0 }}>
      <Tab.Container id="left-tabs-example" defaultActiveKey="1">
        <Row>
          <Col lg={3} md={3} sm={3} xs={12}>
            <p className="small text-muted mb-3 text-uppercase font-weight-bold">{playerCount} Players</p>
            <Nav variant="pills" className="flex-sm-column">
              {predictions.map(analyst => <Analyst {...analyst.fields} />)}
            </Nav>
          </Col>
          <Col lg={9} md={9} sm={9} xs={12}>
            <Tab.Content>
              {predictions.map(picks => <Picks {...picks.fields} />)}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </Card>
  );
}

export default HorseRaceWidget;

